import Script from 'next/script';

import { ClientConfig } from '@/services/clientConfig';

export const RECAPTCHA_LOADED_EVENT = 'recaptchaLoaded';

export function RecaptchaScript() {
  const { recaptchaSiteKey, nonce } = ClientConfig.getInstance().getConfig();

  return (
    <Script
      id="google-recaptcha"
      key="google-recaptcha"
      defer
      strategy="lazyOnload"
      nonce={nonce || undefined}
      src={`https://www.google.com/recaptcha/enterprise.js?render=${recaptchaSiteKey}`}
      onLoad={() => {
        window.dispatchEvent(new Event(RECAPTCHA_LOADED_EVENT));
      }}
    />
  );
}
